import {useCallback, useState} from "react";


export type FieldErrors<K extends string> = {
    [P in K]?: { error: boolean; helperText: string };
};

type FormKeysExt<K extends string> = K | 'form';

export function useFormValidation<K extends string>() {
    const [formError, setFormError] = useState<string | undefined>();
    const [fieldErrors, setFieldErrors] = useState<FieldErrors<K>>({});

    const validate = useCallback((errors: { [P in FormKeysExt<K>]?: false | string | (false | string)[] }) => {
        // setFormError(errors.find(err => !err.key && err.error)?.message);

        let hasErrors = false;
        let formError: string | undefined = undefined;
        const fieldErrors: FieldErrors<K> = {};
        for (const [errorKey, error] of Object.entries(errors) as Array<[FormKeysExt<K>, false | string | Array<false | string>]>) {
            let errorMessage: false | string = false;
            if (error === false || typeof error === 'string') {
                errorMessage = error;
            } else {
                errorMessage = (error as Array<false | string>).find(it => !!it) || false;
            }
            if (errorMessage) {
                hasErrors = true;
                if (errorKey === 'form') {
                    formError = errorMessage;
                } else {
                    fieldErrors[errorKey] = {error: true, helperText: errorMessage};
                }
            }
        }

        setFieldErrors(fieldErrors);
        setFormError(formError);
        return !hasErrors;
    }, [setFieldErrors, setFormError]);


    const reset = useCallback(() => {
        setFormError(undefined);
        setFieldErrors({});
    }, [setFieldErrors, setFormError]);

    return {
        formError,
        fieldErrors,
        validate,
        reset,
    };
}